module.exports = __webpack_public_path__ + "static/media/iq.a66214fe.webp";